import { Translation } from 'cng-common/features/translations/components/translation'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './LocationsListDialogHeader.module.scss'

export const LocationsListDialogHeader = () => {
  return (
    <div className={styles.root}>
      <Translation text={TRANSLATION_KEYS.dialogHeader} span />
    </div>
  )
}
